import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { AdmService } from 'src/app/shared/services/adm.service';
import { DepositosDialogComponent } from './depositos-dialog.component';
import { Deposito } from 'src/app/shared/models/deposito';

@Component({
  selector: 'app-depositos',
  templateUrl: './depositos.component.html'
})
export class DepositosComponent implements OnInit, AfterViewInit {

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private admService: AdmService) { }

  displayedColumns = ['acciones', 'idCompania', 'idSalesOrg', 'idPlanta', 'descripcion', 'cliente', 'habilitacion'];
  dataSource = new MatTableDataSource<Deposito>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  

  public Etiquetas: {
    BotonADeposito: string;
    Buscar: string,
    SinRegistros: string,
    Titulo: string,
    Headers: {
      Acciones: string
      Descripcion: string,
      IdCompania: string,
      IdSalesOrg: string,
      IdPlanta: string,
      Cliente: string,
      Habilitacion: string
      NroClienteDireccionEntrega: string,
    NombreClienteDireccionEntrega: string
    }
  }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }
  ngOnInit(): void {
        if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('ADM LOCAL')) {
      this.router.navigateByUrl('');
    }
    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }
    this.Etiquetas = {
      BotonADeposito: this.configService.etiquetas.Depositos.BotonADeposito,
      Titulo: this.configService.etiquetas.Depositos.Titulo,
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Headers: {
        Acciones: this.configService.etiquetas.Acciones,
        Descripcion: this.configService.etiquetas.Descripcion,
        IdCompania: this.configService.etiquetas.Compania,
        IdSalesOrg: this.configService.etiquetas.SalesOrg,
        IdPlanta:  this.configService.etiquetas.IdPlanta,
        Cliente: this.configService.etiquetas.Depositos.Cliente,
        Habilitacion: this.configService.etiquetas.Habilitacion,
        NroClienteDireccionEntrega: this.configService.etiquetas.Depositos.NroClienteDireccionEntrega,
        NombreClienteDireccionEntrega: this.configService.etiquetas.Depositos.NombreClienteDireccionEntrega

      }
    }
    this.buscar(0);
  }
  buscar(idTipoMensaje: number) {
    this.tablasService
      .cDepositos(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg)
      .subscribe((data: Deposito[]) => {
        this.dataSource.data = [];
        if (data.length) {

          this.dataSource.data = data;

          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  dialogDeposito(idTipo: number, d: Deposito) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { d: d, idTipo: idTipo }
    let dialogRef = this.dialog.open(DepositosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.buscar(idTipo);
      }
    })
  }
  eliminarDeposito(d: Deposito) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del depósito " + d.descripcion + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.tablasService.bDeposito(d).subscribe((data: boolean) => {

            this.buscar(3);
          })
        }
      })
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
